document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('.ajax-add-to-cart-form');

  forms.forEach(form => {
    form.addEventListener('submit', function(event) {
      event.preventDefault(); // Prevent the default form submission
      const formData = new FormData(this); // Gather form data

      const addToCartButton = this.querySelector('button');
      const loadingSpinner = addToCartButton.querySelector('.loading__spinner');
      const metafieldValue = formData.get("properties[variant-type]"); // Get the metafield value of the variant

      const chair_product_id = 9784643649876;
      removeProductFromCartByProductId(chair_product_id);
      // Function to check if a metafield value already exists in the cart
      checkIfProductExistsInCart(metafieldValue)
        .then(exists => {
          if (exists) {
            // If product with same metafield exists, show a message and stop the addition
            displayMessage(addToCartButton, 'A product with the same color is already in the cart.', 'red');
          } else {
            // Proceed to add the product to the cart
            addToCartButton.style.opacity = '0.6';
            loadingSpinner.classList.remove('hidden');
            
            fetch('/cart/add.js', {
              method: 'POST',
              body: formData,
            })
            .then(response => response.json())
            .then(data => {
              console.log('Product added:', data);
              
              addToCartButton.style.opacity = '1';
              loadingSpinner.classList.add('hidden');
              
              displayMessage(addToCartButton, 'Product added to cart', 'green');
            })
            .catch(error => {
              console.error('Error:', error);
            });
          }
        })
        .catch(error => {
          console.error('Error checking cart:', error);
        });
    });
  });

  // Function to display a message
  function displayMessage(button, message, color) {
    // Remove any existing message
    const existingMessage = button.nextElementSibling;
    if (existingMessage && existingMessage.classList.contains('add-to-cart-message')) {
      existingMessage.remove();
    }

    // Create a new message element
    const messageElement = document.createElement('div');
    messageElement.classList.add('add-to-cart-message'); // Add a class for identification
    messageElement.textContent = message;
    messageElement.style.color = color;
    messageElement.style.marginTop = '10px';

    // Append the message below the button
    button.insertAdjacentElement('afterend', messageElement);

    // Remove the message after 5 seconds
    // setTimeout(() => {
      // messageElement.remove();
    // }, 5000);
  }

  // Function to check if a product with the same metafield value is in the cart
  function checkIfProductExistsInCart(metafieldValue) {
    return new Promise((resolve, reject) => {
      $.getJSON('/cart.js', function(cart) {
        let exists = cart.items.some(item => {
          // Assuming the metafield value is stored in item.properties['variant-type']
          return item.properties && item.properties['variant-type'] === metafieldValue;
        });
        resolve(exists);
      }).fail(function(error) {
        reject(error);
      });
    });
  }

  // Accordion (unchanged)
  let collapsibles = document.querySelectorAll(".accordion details");
  if (collapsibles.length > 0) {
    collapsibles.forEach((collapsible, index) => {
      collapsible.addEventListener("click", function(e) {
        e.preventDefault();
        if (collapsible.hasAttribute("open")) {
          collapsible.removeAttribute("open");
        } else {
          collapsible.setAttribute("open", "");
        }
        collapsibles.forEach((element, number) => {
          if (number != index) {
            if (element.hasAttribute("open")) {
              element.removeAttribute("open");
            }
          }
        });
      });
    });
  }

  // Get in Touch (unchanged)
  let getTouch = document.querySelectorAll("a[href='/pages/contact']");
  const contactForm = document.getElementById("footer_contactForm");
  if (getTouch.length > 0) {
    getTouch.forEach((getTouchElm, index) => {
      getTouchElm.addEventListener("click", function(e) {
        console.log(index);
        e.preventDefault();
        if (contactForm) {
          if (index == 0) {
            document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
              summary.click();
            });
          }
          if (getTouchElm.closest('.footer-block__details-content')) {
            if (window.innerWidth < 768) {
              pos = contactForm.offsetTop - 69
            } else {
              pos = contactForm.offsetTop - 112;
            }
          } else {
            pos = contactForm.offsetTop;
          }
          window.scrollTo({top: pos, behavior: 'smooth'});
        } else {
          location.href = "/#footer_contactForm";
        }
      });
    });
  }

  // Function to remove product from cart based on product ID
  function removeProductFromCartByProductId(productId) {
    // Fetch the cart contents
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Find all items in the cart that belong to the product ID
        const itemsToRemove = cart.items.filter(item => item.product_id === productId);
  
        if (itemsToRemove.length > 0) {
          // Loop through each matching item (variant) and remove it by setting its quantity to 0
          itemsToRemove.forEach(item => {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: item.key,  // This is the unique key for the variant in the cart
                quantity: 0    // Set quantity to 0 to remove the item
              }),
            })
            .then(response => response.json())
            .then(cart => {
              console.log('Product variant removed:', item.variant_id);
            })
            .catch(error => console.error('Error removing product variant:', error));
          });
        } else {
          console.log('Product not found in cart.');
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // Page scroll to Footer Contact from (unchanged)
  const scrollToElement = (id) => {
    const element = document.querySelector(id);
    if (element !== null) {
      let pos = element.offsetTop;
      window.scrollTo({top: pos, behavior: 'smooth'});
    }
  };

  window.addEventListener('load', function () {
    if (location.hash !== '') {
      scrollToElement(location.hash);
    }
  });

  // Function to handle button click and page redirect
  const artyButton = document.getElementById('product-arty-view');
  if(artyButton) {
    artyButton.addEventListener('click', function(event) {
      event.preventDefault();

      // Store a flag in localStorage to indicate that the slider should be interacted with
      localStorage.setItem('thumbnailSlider', 'true');

      // Redirect to the product page
      window.location.href = "/products/the-awechair";
    });
  }

  // Function to handle after page redirect
  window.addEventListener('load', function() {
    // Check if the 'thumbnailSlider' query parameter is present in the URL
    const thumbnailSlider = localStorage.getItem('thumbnailSlider');

    if (thumbnailSlider === 'true') {
      // Find the slider and interact with it
      let slider = document.querySelector('.thumbnail-list');
      if (slider) {
        let lastLi = slider.lastElementChild; // Get the last <li> element
        let lastButton = lastLi.querySelector('button'); // Get the button inside the last <li>

        if (lastButton) {
          // Trigger a click event on the last button
          lastButton.click();
        }
        // Window slide to Product section.
        let productSection = document.querySelector('.product');
        productSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start' // Scroll to the top of the element
        });

        // Store a flag in localStorage to indicate that the click event done.
        localStorage.setItem('thumbnailSlider', 'false');
      }
    }
  });

});
